/*
* author: dch
*/
import {ajax} from '@/utils/request';

const api = {
    // 获取客户基本信息
    getCustomerList(data:any) {
        return ajax({
            method: 'get',
            url: `customer-mgt/customer`,
            data
        });
    },
    // 新增客户基本信息
    createCustomer(data:any) {
        return ajax({
            method: 'post',
            url: `customer-mgt/customer`,
            data
        });
    },
    // 修改客户基本信息
    editCustomer(data:any,id:string) {
        return ajax({
            method: 'put',
            url: `customer-mgt/customer/${id}`,
            data
        });
    },
    // 移除客户基本信息
    delCustomer(id:any) {
        return ajax({
            method: 'delete',
            url: `customer-mgt/customer/${id}`,
        });
    }, 
    // 获取客户基本信息
    getCustomerDetails(id:any) {
        return ajax({
            method: 'get',
            url: `customer-mgt/customer/${id}`,
        });
    },
    // 获取客户基本信息
    getProjectsLists(data:any) {
        return ajax({
            method: 'get',
            url: `project-bid-mgt/projects`,
            data
        });
    },
    // 获取客户信息列表
    getAllCustomerLists() {
        return ajax({
            method: 'get',
            url: `customer-mgt/select-customer-list`,
        });
    },
    // 获取部门员工树
    getEmployeesTreeLists() {
        return ajax({
            method: 'post',
            url: `sys-employee-mgt/employees/tree`,
        });
    },
    // 获取员工信息
    getEmployeesData(id:string) {
        return ajax({
            method: 'get',
            url: `sys-employee-mgt/employees/${id}`,
        });
    },
     // 新增项目投标信息
    createProjects(data:any) {
        return ajax({
            method: 'post',
            url: `project-bid-mgt/projects`,
            data
        });
    }, 
    // 移除项目投标信息
    delProject(id:string) {
        return ajax({
            method: 'delete',
            url: `project-bid-mgt/projects/${id}`
        });
    },
    // 获取项目投标信息
    getProjectDetails(id:string) {
        return ajax({
            method: 'get',
            url: `project-bid-mgt/projects/${id}`
        });
    },
    // 修改项目投标信息
    editProject(data:any,id:string) {
        return ajax({
            method: 'put',
            url: `project-bid-mgt/projects/${id}`,
            data
        });
    },
    // 劳务税金列表
    getLabourList(data:any) {
        return ajax({
            method: 'get',
            url: `labour/tax-registration`,
            data
        });
    },
    // 客户项目台账列表
    getCustomerContractList(data:any) {
        return ajax({
            method: 'get',
            url: `customer-mgt/customer/${data.customerId}/contract`,
            data
        });
    },
    // 项目结算分页
    getProjectSettlementLists(data:any) {
        return ajax({
            method: 'get',
            url: `project-settlement-mgt/project-settlement`,
            data
        });
    },
    // 项目结算分页
    getProjectSettlementInfo(id:any) {
        return ajax({
            method: 'get',
            url: `project-settlement-mgt/project-settlement/${id}`
        });
    },
    // 经营部员工
    getBusinessPersonList(data:any) {
        return ajax({
            method: 'post',
            url: `sys-employee-mgt/employees/tree`,
            data
        });
    },
    // 修改项目结算
    setProjectSettlement(data:any,id:any) {
        return ajax({
            method: 'post',
            url: `project-settlement-mgt/project-settlement/${id}`,
            data
        });
    },

};

export default api;